import { useMutation, UseMutationOptions } from "@tanstack/react-query";

import { useServer } from "../../server/ServerContext";
import { PortalAxiosError } from "../../types";
import { OfferData } from "./types";

export const useInviteCode = (
  options?: UseMutationOptions<OfferData, PortalAxiosError, string>
) => {
  const server = useServer();

  return useMutation<OfferData, PortalAxiosError, string>(
    (inviteCode: string) =>
      server.post("offers/invite", { invite_code: inviteCode }),
    options
  );
};

export default useInviteCode;
